import React, { useCallback } from 'react';

import { ReactComponent as IconCross } from 'media/svg/cross.svg';

import { ActiveFilter, FilterAction } from 'proto/Search/ActiveFilter';

import styles from './Element.module.scss';

interface ElementProps {
    activeFilter: ActiveFilter;
    onClick?: (actionList: FilterAction[]) => void;
}

const Element = ({ activeFilter, onClick }: ElementProps) => {
    const clickHandler = useCallback(() => {
        onClick?.(activeFilter.actionList);
    }, [activeFilter.actionList, onClick]);

    return (
        <div
            className={styles.ActiveFilter}
            onClick={clickHandler}
            onKeyUp={() => {}}
            role="link"
            tabIndex={0}
            data-filter={activeFilter.key}
        >
            <span
                className={styles.FilterText}
                dangerouslySetInnerHTML={{ __html: activeFilter.label }}
            />
            <IconCross />
        </div>
    );
};

export default Element;
